query getCreatedContentsStatistics($input: GetCreatedContentsStatisticsInput!) {
  statistics: getCreatedContentsStatistics(input: $input) {
    textKindStatistics {
      textKind
      count
    }
    topicStatistics {
      topicName
      count
    }
  }
}
